/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { PlaybackRestrictionType } from '../../../core/videoplayer/enums';
import { VideoPlaybackController } from '../../../core/videoplayer/VideoPlaybackController';
import { hideVideoDebugOverlay } from '../../videoplayer/videodebugoverlay/videodebugoverlay.reducers';
import { showPCPinOverlayForVideoPlayer } from '../../videoplayer/videoplayer.reducers';
import {
    deleteLastEnteredChannelDigit,
    hideInfoBanners,
    hideStandardInfo,
    setEnteringChannelNumberEnabled,
    showFullInfo,
    showStandardInfo,
    showTrickPlayMenu,
    tuneToEnteredChannelNumber,
    updateStandardInfoBannerTimer,
} from './infobanner.reducers';

export const onKeyBackStandardInfoBanner = () => (dispatch: Function, getState: Function) => {
    const { isVideoDebugOverlayActive } = getState().videoDebugOverlay;
    if (isVideoDebugOverlayActive) {
        dispatch(hideVideoDebugOverlay());
    }
    dispatch(hideStandardInfo());
};

export const onKeyLeftStandardInfoBanner = () => (dispatch: Function, getState: Function) => {
    const { infoBanner } = getState();
    const { enteringChannelNumberEnabled } = infoBanner;
    if (enteringChannelNumberEnabled) {
        dispatch(deleteLastEnteredChannelDigit());
    }
};

export const onKeyOkStandardInfoBanner = () => (dispatch: Function, getState: Function) => {
    const { enteringChannelNumberTimeoutId, enteringChannelNumberEnabled } = getState().infoBanner;
    if (enteringChannelNumberEnabled) {
        dispatch(tuneToEnteredChannelNumber());
        clearTimeout(enteringChannelNumberTimeoutId);
        dispatch(setEnteringChannelNumberEnabled(false));
    }
    const adultRestriction =
        VideoPlaybackController.getInstance().getRestrictionType() ===
        PlaybackRestrictionType.ADULT;
    if (adultRestriction && VideoPlaybackController.getInstance().isNetworkConnected()) {
        dispatch(hideInfoBanners());
        dispatch(showPCPinOverlayForVideoPlayer());
        return;
    }
    dispatch(showTrickPlayMenu());
};

export const onKeyRightStandardInfoBanner = () => (dispatch: Function, getState: Function) => {
    const { infoBanner } = getState();
    const { enteringChannelNumberEnabled } = infoBanner;
    if (enteringChannelNumberEnabled) {
        dispatch(tuneToEnteredChannelNumber());
    }
};

export const onKeyInfoStandardInfoBanner = () => (dispatch: Function) => {
    dispatch(showFullInfo());
};

export const onKeyChannelDownStandardInfoBanner =
    () => (dispatch: Function, getState: Function) => {
        const { infoBanner } = getState();
        const { isStandardInfoActive } = infoBanner;
        if (!isStandardInfoActive) dispatch(showStandardInfo());
        else dispatch(updateStandardInfoBannerTimer());
    };

export const onKeyChannelUpStandardInfoBanner = () => (dispatch: Function, getState: Function) => {
    const { infoBanner } = getState();
    const { isStandardInfoActive } = infoBanner;
    if (!isStandardInfoActive) dispatch(showStandardInfo());
    else dispatch(updateStandardInfoBannerTimer());
};
